// material-ui
import { Theme } from "@mui/material/styles";
import { Box, useMediaQuery } from "@mui/material";

// project import
import Search from "./Search";
import Message from "./Message";
import Profile from "./Profile";
import Notification from "./Notification";
import FullScreen from "./FullScreen";
import MobileSection from "./MobileSection";

import useConfig from "hooks/useConfig";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";

// types
import { MenuOrientation } from "types/config";
import Localization from "./Localization";
import { useMemo } from "react";

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation, i18n } = useConfig();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));
  const localization = useMemo(() => <Localization />, [i18n]);
  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: "100%", ml: 1 }} />}
      {!downLG && localization}
      <Notification />
      <Message />
      {!downLG && <FullScreen />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
